import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Collapse,
  IconButton,
  Rating,
  Typography,
} from '@mui/material';
import React from 'react';
import TagIcon from '@mui/icons-material/Tag';
import InventoryIcon from '@mui/icons-material/Inventory';
import Switch from '@mui/material/Switch';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { CustomSwitch } from 'components/custom-switcher';
const ProductCard = ({ product, handleDeletion, handleActivation , handleEditClick }) => {
  console.log('product', product);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const handleExpandClick = () => {
    setIsExpanded(!isExpanded);
  };
  
 
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>

        <Typography sx={{ fontSize: 14 }} color="primary.light" gutterBottom>
          {product.category.name}
        </Typography>
        <Chip variant="outlined" color={product.is_active ? 'success' : 'secondary'} label={product.is_active ? 'نشط' : 'غير نشط'} size="small" sx={{color: 'text.focus', px: 1}} />
        </Box>
        <Typography
          variant="h5"
          component="div"
          color="text"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {product.name}
        </Typography>
        <Typography sx={{ mb: '1.5rem' }} color="primary.focus">
          {Number(product.price).toFixed(2)}
        </Typography>
        <Rating
          name="read-only"
          value={product.avg_rating || 2.5}
          readOnly
          precision={0.5}
          sx={{ '& .MuiRating-iconEmpty': { color: 'secondary.focus' } }}
        />
        <Typography
          variant="body2"
          sx={{
            fontSize: 14,
            // --- The Magic 4 Lines for Multi-line Truncation ---
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
          }}
        >
          {/* {product.description} */}
        </Typography>
      </CardContent>
      <CardActions sx={{ justifyContent: 'space-between' }}>
        <Button
          variant="primary"
          color="text.focus"
          sx={{
            color: 'text.focus',
            '&:hover': { color: 'text.focus' },
            '&:focus': { color: 'text.focus' },
            '&:active': { color: 'text.focus' },
          }}
          size="small"
          onClick={handleExpandClick}
        >
          {isExpanded ? 'عرض أقل' : '  عرض المزيد '}
        </Button>
        <Box>
          <CustomSwitch
            checked={Boolean(product.is_active)}
            onChange={(e) => handleActivation(product)}
            color="default"
          />
          <IconButton
            aria-label="edit"
            sx={{
              color: 'text.focus',

              
            }}
            onClick={() => handleEditClick(product)}
          >
            <EditIcon fontSize="small" />
          </IconButton>

          <IconButton
            aria-label="delete"
            sx={{
              color: 'error.main',
             
            }}
            onClick={() => handleDeletion(product)}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      </CardActions>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography
            variant="body2"
            sx={{ mr: 1, color: 'secondary.focus', fontSize: 16 }}
          >
            <TagIcon sx={{ mr: 1, color: 'secondary.focus', fontSize: 16 }} /> :{' '}
            {product.id}
          </Typography>
          <Typography sx={{ mr: 1, color: 'secondary.focus', fontSize: 16 }}>
            <InventoryIcon
              color="secondary.focus"
              sx={{ mr: 1, color: 'secondary.focus', fontSize: 16 }}
            />{' '}
            : {product.quantity}
          </Typography>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default ProductCard;
